import { render, staticRenderFns } from "./carrier-manager.vue?vue&type=template&id=36d69608&"
import script from "./carrier-manager.vue?vue&type=script&lang=js&"
export * from "./carrier-manager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports